import { gql } from '@apollo/client'

export const DISPLAY_SHELF_FRAGMENT = gql`
  fragment DisplayShelf on DisplayShelf {
    segmentShelfNumber
    idealInventory {
      upc
      vFacings
      colNum
    }
  }
`
